import { useRef } from 'react';
import { IconChevronDown, IconLoader2 } from '@tabler/icons-react';

export const Select: React.FC<React.SelectHTMLAttributes<HTMLSelectElement> & { showLoadingSpinner?: boolean }> = ({
  children,
  className,
  showLoadingSpinner = false,
  ...props
}) => {
  const selectEl = useRef<HTMLSelectElement | null>(null);

  return (
    <div className="relative">
      <select
        ref={selectEl}
        {...props}
        className={`border-dark-200 h-11 flex-auto cursor-pointer appearance-none rounded border-1 pr-11 pl-2 ${className}`}
      >
        {children}
      </select>

      {showLoadingSpinner && (
        <div className="bg-neutral absolute top-[2px] right-[2px] z-10 flex h-[41px] w-[42px] items-center justify-center border-l-1">
          <IconLoader2 className="text-dark animate-spin" width={22} height={22} />
        </div>
      )}

      {!showLoadingSpinner && (
        <div className="pointer-events-none absolute top-0 right-0 flex h-11 w-11 items-center justify-center border-l-1">
          <IconChevronDown className="text-dark" width={22} height={22} />
        </div>
      )}
    </div>
  );
};
